import { useSelector } from 'react-redux';
import constants from '../components/constants';
import { BASE_URL } from '../components/constants';

export const useOrganizationLogo = () => {
  const { organization, loading } = useSelector((state) => state.theme);
  
  // Get the logo URL - if organization has a logo, use it, otherwise fallback to default
  const getLogoUrl = () => {
    if (organization?.logo_blob_path) {
      return `${BASE_URL}/organizations/media/${organization.organization_id}`;
    }
    return constants.ailogo; // Default logo fallback
  };

  return {
    logoUrl: getLogoUrl(),
    hasCustomLogo: !!organization?.logo_blob_path,
    organization,
    loading
  };
}; 